module.exports = "/packs/images/homepage/facilities/venues_desktop~6d751d0d26d2a06b5d44ac148b740906.jpg";